import type {InterfaceStrings} from './strings'

export const ko: InterfaceStrings = {
    nav: {
        beginSession: '시작하기',
        faq: '자주 묻는 질문',
        pricing: '요금',
        legal: '법적 고지',
        signIn: '로그인',
        viewPricing: '요금 보기',
        signOut: '로그아웃',
        account: '계정',
        menu: '메뉴',
        closeMenu: '메뉴 닫기',
        mainNav: '주 메뉴',
        sessions: {other: '세션 {n}회'},
    },
    footer: {
        selfHypnosisFor: '자기최면',
        anxiety: '불안',
        sleep: '수면',
        stress: '스트레스',
        confidence: '자신감',
        focus: '집중',
        learn: '방법 알아보기',
        ericksonian: '에릭슨 최면이란',
        aiHow: 'AI 최면의 원리',
        vsMeditation: '최면과 명상',
        methods: '기법',
        languages: '언어',
    },
    page: {
        cta: '무료 세션 시작하기',
        hint: '첫 세션은 무료예요',
        exploreFurther: '더 읽어 보기',
        disclaimer:
            'Quies는 휴식과 자기 탐색을 위한 웰니스 도구입니다. 의료기기가 아니며 어떤 질환도 진단, 치료, 완치하지 않습니다. 마음의 위기를 겪고 있다면 전문가에게 도움을 요청하세요.',
        transcript: '대본',
        transcriptNote: '실제 Quies 세션에서 발췌한 부분을, 낭독된 그대로 옮겼습니다.',
        breadcrumb: '탐색 경로',
    },
    pricing: {
        selectPlan: '이 플랜 선택',
        subscribe: '구독하기',
        perMonth: '/ 월',
        manageSubscription: '구독 관리',
        replayFree: '지난 세션을 다시 듣는 것은 언제나 무료입니다.',
        offerLead: '매 세션은 지난 세션이 끝난 곳에서 시작됩니다.',
    },
    session: {
        chooseLanguage: '언어를 선택하세요',
        changeLanguage: '언어 변경',
        changeVoice: '목소리 변경',
        previewVoice: '{voice} 목소리 미리 듣기',
        stopPreview: '미리 듣기 중지',
        continue: '계속',
        composing: 'Quies가 세션을 쓰고 있어요',
        preparing: '명상을 준비하고 있어요',
        pickingUp: '멈춘 곳에서 이어서',
        today: '오늘',
        yesterday: '어제',
        loading: '불러오는 중…',
        showEarlier: '이전 내용 보기 ({count})',
        tryDifferentApproach: '다른 길로 가 보기',
        nothingAdded: '덧붙인 말 없음',
        purchaseConfirmed: '구매가 확인되었습니다',
        firstSessionNote: '첫 세션은 무료입니다. 듣기 전에 로그인해 주세요.',
    },
    threshold: {
        title: '로그인하고 듣기',
        message: '첫 세션은 무료입니다. 카드는 필요 없어요.',
        google: 'Google로 계속하기',
        sendLink: '로그인 링크 받기',
        sending: '보내는 중…',
        emailLabel: '이메일 주소',
        or: '또는',
        waitingTitle: '이메일을 확인하세요',
        waitingBody: '{email}(으)로 로그인 링크를 보냈습니다.',
        sendAgain: '다시 보내기',
        googleInstead: '대신 Google로 로그인',
        codeLabel: '또는 이메일로 받은 6자리 코드를 입력하세요',
        codeSubmit: '계속',
        codeSubmitting: '확인 중…',
        codeWrong: '코드가 올바르지 않습니다.',
        codeDead: '이 코드는 더 이상 사용할 수 없습니다. 이메일의 링크를 사용하거나 새로 보내 달라고 요청하세요.',
        errors: {
            invalidEmail: '올바른 이메일 주소를 입력하세요.',
            rateLimited: '시도가 너무 많습니다. 몇 분 뒤에 다시 시도하세요.',
            sessionError: '로그인에 문제가 생겼습니다. 페이지를 새로 고치고 다시 시도하세요.',
            sendFailed: '이메일을 보내지 못했습니다. 다시 시도하세요.',
            sessionExpired: '로그인 시간이 만료되었습니다. 페이지를 새로 고치고 다시 시도하세요.',
            generic: '문제가 생겼습니다. 다시 시도하세요.',
        },
    },
    player: {
        play: '재생',
        pause: '일시정지',
        playAgain: '다시 듣기',
        seek: '재생 위치',
        eyesClosed: '눈을 감고',
        openEyes: '눈 뜨기',
        paused: '일시정지됨',
        unavailable: '오디오를 재생할 수 없습니다',
        untitled: 'Quies 세션',
    },
    failure: {
        turnFailed: '저희 쪽에서 문제가 생겼습니다. 답변은 저장되어 있어요.',
        reconnecting: '다시 연결하는 중…',
        refusalTitle: '다른 길로 가 봐요',
        refusal: '메시지의 일부에 답할 수 없었습니다. 다르게 표현하거나 다시 보내 주세요.',
        openElsewhere: '이 세션은 다른 창에서도 열려 있습니다.',
        serviceDown: '지금은 Quies에 연결할 수 없습니다. 지금까지 한 것은 사라지지 않았어요.',
        sessionsUsedTitle: '세션을 모두 사용하셨습니다',
        voiceFailedTitle: '명상은 다 쓰였습니다',
        voiceFailed: '지금은 목소리로 만들 수 없었습니다. 잃은 것은 없으며, 다시 낭독해도 비용이 들지 않아요.',
        voiceStopped: '목소리가 중간에 멈췄습니다. 멈춘 곳에서부터 이어 갈 수 있어요.',
        streamMissing: '명상은 준비되었지만 이 페이지에 도착하지 않았습니다.',
        tapToListen: '탭해서 듣기',
        fileFailed: '이 녹음은 재생되지 않습니다. 명상을 무료로 다시 낭독할 수 있어요.',
        recordingGone: '이 녹음은 더 이상 보관되지 않습니다.',
        purchaseCancelled: '구매가 취소되었습니다. 청구된 금액은 없습니다.',
        purchasePending: '결제가 확인되었습니다. 세션이 평소보다 늦게 도착하고 있어요.',
        checkoutFailed: '결제를 완료할 수 없었습니다. 청구된 금액은 없습니다.',
        sessionEnded: '이 세션은 끝을 맺었습니다.',
        busy: '지금 Quies 이용자가 많습니다. 답변은 저장되어 있으니 1분 뒤에 다시 시도해 주세요.',
        tooLong: '이 세션이 Quies가 감당할 수 있는 길이를 넘었습니다. 세션 1회를 돌려드렸어요.',
        notSaved: '이 단계를 저장하지 못했습니다. 여기서부터 이어 가려면 다시 시도해 주세요.',
        meditationRefused:
            '이 명상은 요청하신 대로 쓸 수 없었습니다. 다르게 표현하거나 새로 시작해 주세요. 이 세션 1회는 돌려드립니다.',
        meditationRefusedUncharged: '이 명상은 요청하신 대로 쓸 수 없었습니다. 다르게 표현하거나 새로 시작해 주세요.',
        linkExpired: '로그인 링크가 만료되었습니다. 새 링크를 요청하세요.',
        oauthFailed: '로그인이 중단되었습니다. 다시 시도해 주세요.',
        offline: '오프라인 상태입니다. 연결이 돌아오는 대로 답변을 보낼게요.',
        voiceChanged: '선택한 목소리를 더 이상 쓸 수 없어, 다른 목소리가 이 명상을 읽습니다.',
        voiceReturned: '여전히 목소리를 만들 수 없었습니다. 세션 1회를 돌려드렸어요.',
        voiceFailedAgain: '여전히 목소리를 만들 수 없었습니다.',
        voiceResuming: '목소리가 다시 이어지고 있어요…',
        voiceLimited: '이번 한 시간 동안 이미 여러 명상을 낭독해 드렸어요. 조금 뒤에 다시 시도해 주세요.',
        tryAgain: '다시 시도',
        rephrase: '다르게 표현하기',
        resume: '이어 듣기',
        voiceAgain: '다시 낭독하기',
        listen: '듣기',
        continue: '계속',
        begin: '세션 시작하기',
        signIn: '로그인',
        checkAgain: '다시 확인',
        sendLink: '로그인 링크 보내기',
        useEmail: '이메일로 계속하기',
    },
}
